import {
  FC,
  useState,
  useMemo,
  useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Alert, Snackbar } from '@mui/material';
import Slide, { SlideProps } from '@mui/material/Slide';

import { useTypedDispatch } from 'hooks/useTypedDispatch';
import { setApiError } from 'store/app/appReducer';
import { apiErrorSelector } from 'store/app/appSelectors';
import { convertApiError } from 'utils/errorUtil';

const DURATION = 3000;

const TransitionDown = (props: SlideProps) => {
  return <Slide {...props} direction="down" />;
};

export const ErrorMessage: FC = () => {
  const { t } = useTranslation('errors');
  const dispatch = useTypedDispatch();

  const apiError = useSelector(apiErrorSelector);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const onClose = () => setIsOpen(false);

  const convertedError = useMemo(() => (apiError ? convertApiError(apiError) : null), [apiError]);

  useEffect(() => {
    if (convertedError == null) {
      return;
    }

    const { message, options, printMessage } = convertedError;
    const m = options ? t(message, options) : t(message);

    if (printMessage) {
      console.error(message);
    }

    setIsOpen(true);
    setMessage(m);
    dispatch(setApiError(null));
  }, [convertedError, t]);

  return (
    <Snackbar
      style={{ zIndex: 10001 }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isOpen}
      autoHideDuration={DURATION}
      onClose={onClose}
      TransitionComponent={TransitionDown}
    >
      <Alert
        onClose={onClose}
        severity="error"
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
